import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { Logger } from "./Logger";
import { logout } from "./auth";
const DADOS_LOGIN = "dados_login_forn";
const TOKEN_REFRESH = "token_refresh_forn";
const TOKEN_KEY = "token_key_forn";
const TOKEN_KEY_CAT = "token_key_catalogo";

// URLs definidas nos arquivos .env de cada ambiente (ver .env.example e scripts/env.js)
export const apiForn = axios.create({ baseURL: process.env.REACT_APP_API_URL });
export const apiLogIn = axios.create({ baseURL: process.env.REACT_APP_API_URL });
export const apiCat = axios.create({ baseURL: process.env.REACT_APP_API_CATALOGO_URL });
export const apiCep = axios.create({ baseURL: process.env.REACT_APP_API_CEP_URL });

apiForn.interceptors.request.use(async config => {
  if (localStorage.getItem(TOKEN_REFRESH) == "true") {
    var token = localStorage.getItem(TOKEN_KEY);
    const decoded = jwtDecode(token, { complete: true });
    if (decoded !== null) {
      var dataDecodada = (decoded.exp * 1000);
      var dataSeg = new Date(dataDecodada - 150000);
      var dataExpirado = dataSeg.getTime();

      var dataSeg2 = new Date();
      var dataAgora = dataSeg2.getTime();
      if (dataAgora > dataExpirado) {
        localStorage.setItem(TOKEN_REFRESH, "false");
        var dadosToken = JSON.parse(localStorage.getItem(DADOS_LOGIN));
        const defaultOptions = {
          headers: {
            "Content-Type": "application/json"
          }
        };
        var dados = {
          "token": dadosToken.refresh_token,
          "Grant_Type": "refresh_token"
        };
        var retorno = await apiLogIn.post("Account/Refresh", JSON.stringify(dados), defaultOptions);
        if (retorno.data.sucesso) {
          token = retorno.data.result.access_token;
          const decoded = jwtDecode(retorno.data.result.access_token, { complete: true });
          retorno.data.result.FullName = decoded.FullName;
          await localStorage.setItem(TOKEN_KEY, token);
          await localStorage.setItem(DADOS_LOGIN, JSON.stringify(retorno.data.result));
          localStorage.setItem(TOKEN_REFRESH, "true");

          dataSeg = new Date(dataDecodada - 100000);
          dataExpirado = dataSeg.getTime();
          if (dataAgora > dataExpirado) {
            window.location = window.location.href;
          }
        } else {
          logout();
        }
      }
    }
    config = await Logger(config);
    config.headers.common['Authorization'] = `bearer ${token}`;
    config.headers.common['Content-Type'] = `application/json`;
    return config;
  } else {
    // setTimeout(() => ResetaCache(), 5000);
    return false;
  }
});

const ResetaCache = () => {
  if (localStorage.getItem(TOKEN_REFRESH) === "true") {
    //
  } else {
    localStorage.setItem(TOKEN_REFRESH, "true");
    window.location = window.location.href;
  }
};

apiForn.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return error.response;
});

apiLogIn.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return error.response;
});

apiCat.interceptors.request.use(async config => {
  var token = localStorage.getItem(TOKEN_KEY_CAT);
  if (
    token !== "undefined" &&
    token !== undefined &&
    token !== null &&
    token !== ""
  ) {
    config.headers.common["Authorization"] = `bearer ${token}`;
  }
  config.headers.common['Content-Type'] = `application/json`;
  return config;
});

apiCat.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return error.response;
});

apiCep.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return error.response;
});
